<template>
  <div
    v-if="loading"
    id="page"
    class="flex flex-col items-center justify-center min-h-screen w-full"
  >
    <div
      class="spinner mx-auto"
      style="border: 3px solid rgb(141 183 227 / 30%);border-top-color: #80b1fc;"
    ></div>
    <div class="p-4" style="color: rgb(78 143 243);">
      Loading, please wait...
    </div>
  </div>
  <div v-else id="page" class="min-h-screen w-full">
    <div class="">
      <Navbar
        id="header"
        class="bg-white border-b border-solid border-gray-200 opacity-100 py-2 px-10 shadow"
      >
        <template v-slot:left>
          <div id="name" class="flex flex-row">
            <router-link
              :to="{ name: 'survey-list' }"
              class="px-4 text-lg font-bold border border-transparent cursor-pointer rounded text-purple-600 hover:no-underline"
              >AppFlowz
            </router-link>
          </div>
        </template>
      </Navbar>

      <div class="mt-5 px-10">
        <router-link
          :to="{ path: '/results/' + survey.id }"
          class="px-4 font-normal align-middle text-sm border border-transparent cursor-pointer rounded text-gray-400 hover:no-underline hover:text-purple-400"
        >
          <svg-icon
            icon="heroicons/outline/arrow-left"
            class="h-4 w-4 inline-block align-middle"
          ></svg-icon>
          Back to results
        </router-link>
      </div>

      <!--Delete Modal -->
      <BaseModal
        :showModal="showDeleteModal"
        v-on:close="showDeleteModal = false"
        v-on:confirm="
          deleteResponses();
          showDeleteModal = false;
        "
      >
        <template v-slot:body>
          <p class="text-sm text-gray-500">
            Are you sure you want to delete all of this visitor's responses?
            This action cannot be undone.
          </p>
        </template>
      </BaseModal>

      <div class="mt-10 px-10">
        <!-- Start -->
        <div class="bg-white shadow overflow-hidden sm:rounded-lg max-w-5xl mx-auto">
          <div class="px-4 py-5 sm:px-6">
            <div class="flex flex-row justify-between items-center">
              <div>
                <h3 class="text-base leading-6 font-medium text-gray-800">
                  {{ dataset.name }} {{ dataset.email }}
                </h3>
                <div class="mt-1 max-w-2xl text-sm text-gray-500">
                  Created at {{ new Date(Date.parse(dataset.created_at)) }}
                </div>
              </div>

              <div @click="confirmDelete">
                <svg-icon
                  icon="heroicons/outline/trash"
                  class="h-6 w-6 cursor-pointer text-gray-500 hover:text-gray-400"
                />
              </div>
            </div>
          </div>

          <div class="border-t border-gray-200">
            <div v-for="(step, index) in steps" :key="index">
              <div class="px-4 py-5 sm:px-6" :class="rowColor(index)">
                <div class="font-medium text-gray-600">
                  <div
                    class="inline-block py-1 px-3 mr-2 text-sm bg-purple-300 rounded border-solid border-purple-400 font-bold"
                  >
                    {{ index + 1 }}
                  </div>
                  {{ step.title }}
                </div>
                <div class="text-sm text-gray-900 sm:mt-2">
                  {{
                    dataset.results[step.id]
                      ? dataset.results[step.id]
                      : "(No response recieved.)"
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from "@/components/Header";
//import SidebarComponent from "@/components/CreativeTim/Sidebar.vue";
import Survey from "@/models/Survey";
import Response from "@/models/Response";
import Visitor from "@/models/Visitor";
import router from "@/router/route.js";
import axios from "axios";

export default {
  name: "visitor-responses",
  components: {
    Navbar,
    //SidebarComponent,
  },
  data() {
    return {
      loading: false,
      downloading: false,
      showDeleteModal: false,
      dataset: [],
    };
  },
  props: ["surveyid", "visitorid"],
  computed: {
    survey() {
      return Survey.query()
        .whereId(this.surveyid)
        .with("steps", (query) => {
          query.orderBy("order", "asc");
        })
        .first();
    },
    steps() {
      //filter out welcome step or thank you step 
      return this.survey.steps.filter(step => step.type != 'end' && step.type != 'welcome' );
    },
    visitor() {
      return Visitor.query()
        .where("id", this.visitorid)
        .first();
    },
  },
  methods: {
    async init() {
      var id = this.surveyid || null;

      if (id === null) {
        console.log("Error, survey not found.");
        router.push({ name: "survey-list" });
      }

      this.loading = true;

      //if survey is not already loaded in state, request it from the server
      if (this.survey === null) {
        await Survey.api().get("/api/survey/" + id, {
          dataKey: "data",
        });
      }

      //if visitor is not already loaded in state, try to load it from server
      if (this.visitor === null) {
        await Visitor.api().get("/api/visitor/" + this.visitorid, {
          dataKey: "data",
        });
      }
      this.loadResponses();

      this.loading = false;
    },
    //Retrieve this visitor's responses from server and load to this.dataset
    loadResponses() {
      axios
        .get(`api/response/survey/${this.surveyid}/visitor/${this.visitorid}`)
        .then((response) => {
          this.dataset = response.data.data;
        })
        //if user request fails
        .catch(() => {
          //
        });
    },
    rowColor(index) {
      //check if even numbered row
      if (index % 2 == 0) return "bg-white";
      else return "bg-gray-50";
    },
    confirmDelete() {
      this.showDeleteModal = true;
    },

    async deleteResponses() {
      //Delete step from database
      await Response.api()
        .delete(
          `/api/response/delete/${this.survey.id}/visitor/${this.visitor.id}`
        )
        .then(() => {
          //On success, delete step from entities state
          Response.delete(this.step.id);
          Response.delete((response) => {
            return (
              response.visitor_id == this.visitor_id &&
              response.survey_id == this.survey.id
            );
          });
          // router.push
        })
        .catch(function(error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
          self.$store.dispatch("notification/add", {
            message: "An error occured deleting step",
          });
        });
    },
  },
  created() {
    this.init();
  },
};
</script>

<style></style>
